import { RemoteShellController } from '../controller/RemoteShellController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class RemoteShellWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: RemoteShellController,
    });
  }

  set hasError(value: boolean) {
    this.setAttribute('data-has-error', JSON.stringify(value));
  }

  get hasError(): boolean {
    return !!this.getAttribute('data-has-error');
  }
}
